import React from 'react'
import { createContainer } from '@dbk-legacy/muster/react'
import Modal from '@dbk/ui-modal'
import Text from '@dbk/ui-text'
import Button from '@dbk/ui-buttons'
import { TextInput } from '@dbk/ui-forms';
import { FormattedMessage } from '@dbk/format';
import { DOCSIGN_CONSTANTS } from '../../../constants';
import Loading from '../../../components/common/loading/loading-circle';

class AcceptSignRejectModal extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      comments: '',
      loading: false,
      actionInProgress: false,
      onClosingDialog: false
    };

    this.onClose = this.onClose.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.acceptsign.actionAcceptResponse !== this.props.acceptsign.actionAcceptResponse
      && this.props.acceptsign.actionAcceptResponse.data.status.toLowerCase() === DOCSIGN_CONSTANTS.SUCCESS_RESPONSE) {
      this.setState({ loading: false, actionInProgress: false });
      this.props.changePage('/portfolios', true);
      this.props.changePage('/docsign/document-list');
    } else if (prevProps.acceptsign.actionAcceptResponse !== this.props.acceptsign.actionAcceptResponse || prevProps.acceptsign.numOfActionCalls !== this.props.acceptsign.numOfActionCalls) {
      this.setState({ loading: false, actionInProgress: false });
    }
  }

  componentWillUnmount() {
    this.props.setActionAcceptResponseError('');
  }

  onOkButtonClicked = () => {
    this.setState({ loading: true, actionInProgress: true });
    const { acceptsign: { acceptViewResponse } } = this.props;
    this.props.getActionAccept(
      acceptViewResponse.data.txId,
      DOCSIGN_CONSTANTS.REJECT,
      this.state.comments);
  }

  onClose() {
    this.setState({ loading: true, actionInProgress: true, onClosingDialog: true });
    const { acceptsign: { acceptViewResponse } } = this.props;
    this.props.getActionAccept(
      acceptViewResponse.data.txId,
      DOCSIGN_CONSTANTS.CANCEL,
      this.props.acceptsign.documentName);
  }

  render() {
    const {
      i18n: { messages },
      acceptsign: { actionAcceptResponseError }
    } = this.props;
    const {
      actionInProgress,
      onClosingDialog
    } = this.state
    const charLimit = 50;
    return (
      <Modal
        isActive
        disableOutsideClick
        onClose={this.onClose}
        header={messages['app.docsign.acceptsign.reject.confirmation']}
        content={
          <div>
            {actionInProgress ?

              <div className="padding-top-50 padding-bottom-50">
                <Loading />
                {!onClosingDialog &&
                  <Text className="center-content" secondary> {messages['app.docusign.digisign.processinfo']}</Text>}
              </div>

              :
              <div className="acceptsign-modal">
                <div className="modal-content">
                  {actionAcceptResponseError !== '' && actionAcceptResponseError !== undefined && actionAcceptResponseError !== null &&
                    <Text className="center-content" secondary>{actionAcceptResponseError}</Text>
                  }
                  <Text>
                    <FormattedMessage id={'app.docsign.acceptsign.reason.for.rejection'} values={{ documentName: this.props.acceptsign.documentName }} />
                  </Text>
                  <div>
                    <Text>
                      <FormattedMessage id={'app.docsign.acceptsign.max.characters'} values={{ charLimit: charLimit }} />
                    </Text>
                  </div>
                  <div className="modal-content__text-area">
                    <TextInput
                      placeholder={messages['app.docsign.acceptsign.mandatory']}
                      spellCheck="false"
                      maxLength={charLimit}
                      size="small"
                      numberOfLines={1}
                      onChange={(ev) => this.setState({ comments: ev.target.value })}
                    />
                  </div>
                  <Text className="modal-content__text-counter">
                    {"(" + this.state.comments.length + "/" + charLimit + ")"}
                  </Text>
                </div>
                <div className="submit-btn">
                  <Button
                    loading={this.state.loading}
                    disabled={this.state.comments.trim().length === 0}
                    onPress={this.onOkButtonClicked} >
                    {messages['app.rating.submit']}
                  </Button>
                </div>
              </div>
            }
          </div>
        }
      />
    )
  }
}
export default createContainer({
  $queries: {
    i18n: { messages: true },
    changePage: { $call: 'ui.history.push' },
    acceptsign: {
      documentName: true,
      acceptViewResponse: true,
      actionAcceptResponse: true,
      actionAcceptResponseError: true,
      numOfActionCalls: true
    },
    getActionAccept: { $call: 'acceptsign.getActionAccept' },
    setActionAcceptResponseError: { $set: 'acceptsign.actionAcceptResponseError' }
  },
})(AcceptSignRejectModal);